export default __webpack_public_path__ + "maps-examples-annotation-views-960-0411080e8ec8b7f2370b82ac1cc4272b.png";